// TODO: consider to fetch values from database
const Role = {
  SUPERADMIN: { label: 'SuperAdmin', id: 1, name: 'СуперАдмин' },
  ADMIN: { label: 'Admin', id: 2, name: 'Админ' },
  OPERATOR: { label: 'Operator', id: 3, name: 'Оператор' },
  CASHIER: { label: 'Cashier', id: 4, name: 'Кассир' },
  COURIER: { label: 'Courier', id: 5, name: 'Курьер' },
  CHIEF_CASHIER: { label: 'ChiefCashier', id: 6, name: 'Старший Кассир' },
  CHIEF_OPERATOR: { label: 'ChiefOperator', id: 7, name: 'Старший Оператор' },
  FINANCE: { label: 'Finance', id: 8, name: 'Бухгалтер' },
};

const GRAM = 'г';
const ROUBLE = '₽';
const CALORIES = 'ккал';

const all = [
  Role.SUPERADMIN,
  Role.ADMIN,
  Role.OPERATOR,
  Role.CASHIER,
  Role.COURIER,
  Role.CHIEF_CASHIER,
  Role.CHIEF_OPERATOR,
  Role.FINANCE,
].map(({ label }) => label);

const cashierAndOperatorToSuperAdmin = [
  Role.SUPERADMIN,
  Role.ADMIN,
  Role.OPERATOR,
  Role.CHIEF_OPERATOR,
  Role.CHIEF_CASHIER,
  Role.CASHIER,
].map(({ label }) => label);

const operatorToSuperAdmin = [
  Role.SUPERADMIN,
  Role.ADMIN,
  Role.CHIEF_OPERATOR,
  Role.OPERATOR,
].map(({ label }) => label);

const chiefOperatorToSuperAdmin = [
  Role.SUPERADMIN,
  Role.ADMIN,
  Role.CHIEF_OPERATOR,
].map(({ label }) => label);

const cashierToSuperAdmin = [
  Role.SUPERADMIN,
  Role.ADMIN,
  Role.CHIEF_CASHIER,
  Role.CASHIER,
].map(({ label }) => label);

const financeToSuperAdmin = [Role.SUPERADMIN, Role.ADMIN, Role.FINANCE].map(
  ({ label }) => label
);

const adminToSuperAdmin = [Role.SUPERADMIN, Role.ADMIN].map(
  ({ label }) => label
);

const roleSet = {
  all,
  cashierAndOperatorToSuperAdmin,
  chiefOperatorToSuperAdmin,
  operatorToSuperAdmin,
  cashierToSuperAdmin,
  financeToSuperAdmin,
  adminToSuperAdmin,
  superAdmin: [Role.SUPERADMIN.label],
};

export { Role, roleSet, GRAM, ROUBLE, CALORIES };
